import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageWorkflowProfileNextStatusSlideout extends Layout {
    sourceBrokerageWorkflowNextStatus: DataSource;
    tableStatusCodes: Table;
}
